import React from "react";

import CloseIcon from "../../../assets/images/close-icon.svg";
import { getTranslation } from "../../../helpers/getLanguage";
import Dialog from "../Dialog";
import "./styles.css";

const TrashModal = ({
  disabled = false,
  closeDialog,
  message,
  children,
  onProceed,
  closeOnClickOutside = true,
  closeOnEscape = true,
  proceedButtonText = "Proceed",
  goToBinButtonText = "Go To Recycle Bin",
  cancelButtonText = "CANCEL",
  hideCloseIcon = false,
  messageWidth = 0,
  autoFocus = false,
  messageHeight = 0,
  className,
  textContainerClass,
  itemType = "projects",
  itemsCount = 0,
  storageLimit = 50,
  history,
}) => {
  const handleCloseDialog = () => {
    closeDialog && closeDialog();
  };

  const onGoToRecycleBin = () => {
    history.push("/trash");
  };

  const popupTextStyles = {};
  if (messageWidth) {
    popupTextStyles.width = messageWidth;
  }
  if (messageHeight) {
    popupTextStyles.minHeight = messageHeight;
  }

  const defaultMessage =
    message ||
    `Deleting these ${itemType} would exceed the ${storageLimit} ${itemType} storage limit in the recycle bin. ` +
      `If you proceed, only ${itemsCount} ${itemType} would be added to the bin.`;

  return (
    <Dialog closeDialog={closeDialog} closeOnClickOutside={closeOnClickOutside} closeOnEscape={closeOnEscape}>
      <div className={`trash-popup flex-column ${className}`}>
        <div className="trash-popup-close flex width-100">
          {!hideCloseIcon && <img src={CloseIcon} alt="" className="pointer" onClick={handleCloseDialog} />}
        </div>

        <div className="flex-center height-100">
          <div className="flex-column align-center">
            {!children ? (
              <span className={`trash-popup-text ${textContainerClass}`} style={popupTextStyles}>
                {defaultMessage}
              </span>
            ) : (
              children
            )}

            <div className="flex width-100 justify-center button-group">
              <button className="trash-popup-cancel-button" disabled={disabled} onClick={handleCloseDialog}>
                <span>{cancelButtonText}</span>
              </button>

              <button
                className="trash-popup-proceed-button"
                autoFocus={autoFocus}
                disabled={disabled}
                onClick={() => {
                  onProceed && onProceed();
                  handleCloseDialog();
                }}
              >
                <span>{getTranslation(proceedButtonText)}</span>
              </button>
            </div>

            <div className="recycle-bin-link-container">
              <a
                className="recycle-bin-link"
                onClick={(e) => {
                  e.preventDefault();
                  onGoToRecycleBin();
                  handleCloseDialog();
                }}
              >
                {goToBinButtonText}
              </a>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default TrashModal;
